<template>
  <div>
    <a-modal
      width="800px"
      v-model="visible"
      title="新增分配"
      @cancel="visible = false"
    >
      <template slot="footer">
        <a-button @click="visible = false">取消</a-button>
        <a-button type="primary" @click="handleOk">确定</a-button>
      </template>
      <a-form :labelCol="labelCol" :wrapperCol="wrapperCol" :form="form">
        <a-row :gutter="24">
          <a-col :md="12" :sm="8">
            <a-form-item label="子产品">
              <a-select
                mode="multiple"
                :showSearch="true"
                optionFilterProp="label"
                @change="handleChange"
                style="width: 100%"
                placeholder="请选择子产品"
                v-decorator="['sonProduct']"
              >
                <a-select-option
                  :label="item.fundName"
                  v-for="item in productList"
                  :key="item.fundCode"
                >
                  {{ item.fundName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="8" style="text-align:left;">
            <a-button type="primary" @click="addSonProduct">确认添加</a-button>
          </a-col>
        </a-row>
      </a-form>

      <div style="text-align:left;margin-bottom:10px">已添加</div>
      <a-table
        bordered
        rowKey="id"
        :columns="columns"
        :data-source="dataSource"
        :pagination="false"
        :loading="loading"
      >
        <span slot="action" slot-scope="text, record" class="handelDel">
          <a-button @click="handleDelete(record)">取消分配</a-button>
        </span>
      </a-table>
    </a-modal>
  </div>
</template>
<script>
import { postTag, postAction } from '@/api/manage';
import moment from 'moment';
const columns = [
  {
    title: '产品名称',
    align: 'center',
    dataIndex: 'fundName',
    ellipsis: true
  },
  {
    title: '产品代码',
    align: 'center',
    dataIndex: 'fundCode',
    ellipsis: true,
    customRender: text => {
      return !text || text == '' ? '--' : text;
    }
  },
  {
    title: '操作',
    dataIndex: 'action',
    align: 'center',
    scopedSlots: { customRender: 'action' }
  }
];

export default {
  data() {
    return {
      form: this.$form.createForm(this),
      childrenIds: [], //子产品id
      columns,
      loading: false,
      visible: false,
      selectedRowKeys: [],
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      selectManagers: [],
      dataSource: [],
      productList: [],
      managerIds: [],
      fundCode: '',
      id: '',
      url: {
        available:
          process.env.VUE_APP_CMS_PRODUCT + '/product/fund/sub/available',
        list: process.env.VUE_APP_CMS_PRODUCT + '/product/fund/sub/list',
        save: process.env.VUE_APP_CMS_PRODUCT + '/product/fund/join',
        remove: process.env.VUE_APP_CMS_PRODUCT + '/product/fund/remove/sub'
      }
    };
  },
  mounted() {
    // this.getSubList();
  },
  methods: {
    getSubList() {
      let params = {
        pageNo: 1,
        pageSize: 10000
      };
      postTag(this.url.available, params).then(res => {
        if (res.success) {
          this.productList =
            res.result && res.result.records ? res.result.records : [];
        }
      });
    },
    getMomentList() {
      let params = {
        fundCode: this.fundCode,
        id: this.id,
        pageNo: 1,
        pageSize: 100000
      };
      postTag(this.url.list, params).then(res => {
        if (res.success) {
          console.log(res);
          this.dataSource =
            res.result && res.result.records ? res.result.records : [];
        }
      });
    },
    handleChange(value) {
      console.warn(value);
      this.managerIds = value;
    },
    handleDelete(record) {
      let index = this.dataSource.findIndex(
        item => item.fundCode == record.fundCode
      );

      if (index > -1) {
        this.dataSource.splice(index, 1);
      }
      this.childrenIds.push(record.id);
    },
    //添加子产品
    addSonProduct() {
      let infp = this.form.getFieldValue('sonProduct');
      console.warn(infp.length);
      if (infp.length == 0) {
        this.$message.error('请选择子产品');
        return;
      }
      let arr = [];
      // let managerArr = [];
      // managerArr.push(this.managerIds);
      if (this.managerIds && this.managerIds.length > 0) {
        this.managerIds.forEach(item => {
          let obj = this.productList.find(e => e.fundCode == item);
          if (obj) {
            arr.push(obj);
          }
        });
      }

      if (this.dataSource.length == 0) {
        this.dataSource = this.dataSource.concat(arr);
      } else {
        let isConcat = true;
        arr.forEach((item, index) => {
          this.dataSource.map(pre => {
            if (item.id == pre.id) {
              isConcat = false;
              this.$message.warning('不能添加重复子产品');
              return;
            }
          });
        });

        if (isConcat) {
          this.dataSource = this.dataSource.concat(arr);
        }
      }
      this.$nextTick(() => {
        this.form.setFieldsValue({ sonProduct: [] });
      });
    },
    //确认添加
    handleOk() {
      let that = this;
      if (that.dataSource.length <= 0) {
        that.$message.warning('至少选择一个子产品');
        return;
      } else {
        let params = {
          fundCode: this.fundCode,
          subFundCodes: this.managerIds
        };

        let queryData = {
          ids: this.childrenIds
        };
        if (this.childrenIds.length == 0) {
          if (params.subFundCodes.length == 0) {
            that.$message.warning('至少选择一个子产品');
            return;
          }
          postTag(this.url.save, params).then(res => {
            if (res.success) {
              this.$message.success('操作成功');
              this.getMomentList();
              this.managerIds = [];
              this.visible = false;
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          postTag(this.url.remove, queryData).then(res => {
            if (res.success) {
              this.visible = false;
              if (params.subFundCodes.length == 0) {
                this.$message.success('操作成功');
                return;
              }
              this.$nextTick(() => {
                postTag(this.url.save, params).then(res => {
                  if (res.success) {
                    this.$message.success('操作成功');
                    this.getMomentList();
                    this.visible = false;
                    this.managerIds = [];
                  } else {
                    this.$message.error(res.message);
                  }
                });
              });
            } else {
              this.$message.error(res.message);
            }
          });
        }
      }
    },
    handleVisible(record) {
      this.id = record.id;
      this.fundCode = record.fundCode;
      console.warn(record);
      this.getMomentList();
      this.getSubList();
      this.visible = true;
    }
  }
};
</script>
